import { type Clip } from '@air/api/types';
import { type AppNode } from '@air/feature-edit-canvas';

import { clipToAppNode, DEFAULT_DIMENSION, NODE_SPACING } from '~/components/Modals/AddToCanvasModal/clipToAppNode';

export function clipsToAppNodes(clips: Clip[]): AppNode[] {
  let offsetX = 0;

  return clips.map((clip) => {
    const node = clipToAppNode(clip, offsetX);
    offsetX += (clip.width || DEFAULT_DIMENSION) + NODE_SPACING;
    return node;
  });
}
